import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";

import NoResultsFound from "../../common/components/noResultsFound/NoResultsFound";
import { PropsWithClassName } from "../../common/types/PropsWithClassName";
import { fetchTeamsByDepartment } from "./teamsApi";
import { Team } from "./Team";

interface TeamsDropdownProps extends PropsWithClassName {
  placeholder?: string;
  showClear?: boolean;
  departmentId: string;
  value?: string;
  onChange: (teamId?: string) => void;
  disabled?: boolean;
}

export default function TeamsDropdown({ className, placeholder, showClear, departmentId, value, onChange, disabled }: TeamsDropdownProps) {
  const [allTeams, setAllTeams] = useState<Team[]>([]);
  const selectedTeam = allTeams.find((team) => team.id === value);

  useEffect(() => {
    const doFetchTeamsByDepartment = async () => {
      if (departmentId) {
        const teams = await fetchTeamsByDepartment(departmentId);
        const sortedTeams = teams.sort((a, b) => a.name.localeCompare(b.name));
        setAllTeams(sortedTeams);
      }
    };
    doFetchTeamsByDepartment();
  }, [departmentId]);

  return (
    <Dropdown
      className={`${className}`}
      placeholder={placeholder}
      optionLabel="name"
      options={allTeams}
      value={selectedTeam}
      showClear={showClear}
      emptyMessage={<NoResultsFound />}
      disabled={disabled}
      onChange={(e) => onChange(e.value?.id)}
    />
  );
}
